import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';

import { JwtHelperService } from '@auth0/angular-jwt';

import { AuthService } from '../services/auth.service';

const helper = new JwtHelperService();

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const userToken = JSON.parse(localStorage.getItem('userToken'));

    if (request.url.includes('refresh')) {
      return next.handle(request);
    }

    if (userToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${userToken.token}`
        }
      });

      return next.handle(request);
    }

    return next.handle(request);
  }
}
